import { NavLink, Prompt, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Formik, FormikHelpers } from 'formik'
import * as Yup from 'yup'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'

import { Auth } from 'services/Api'
import { Alert, Card } from 'ui'
import { Card as MerinioCard } from 'components/UI'

import { Button, Input, Form } from 'components/Forms'
import { FC } from 'react'

type InitialValues = {
  email: string
}

const ForgotUsername: FC = () => {
  const history = useHistory()
  const { t } = useTranslation('legacy')

  const co = useSelector((state: MStore.RootState) => state.auth.co)

  const ForgotUsernameSchema = Yup.object().shape({
    email: Yup.string().email('auth.MUST_BE_A_VALID_EMAIL').min(2, 'auth.TOO_SHORT').max(70, 'auth.TOO_LONG').required('auth.REQUIRED')
  })

  const initialValues: InitialValues = {
    email: ''
  }

  const onSubmit = async (values: InitialValues, actions: FormikHelpers<InitialValues>) => {
    const { email } = values

    try {
      const res = await Auth.post('/forget/username', { email, co })
      actions.setSubmitting(false)
      if (!res.success) {
        return actions.setStatus({ msg: `auth.${res.message}` })
      }
      actions.resetForm({ values: { email: '' } })
      //Send back the user to the login page with a state that will allow to show a confirmation alert
      history.push({ pathname: '/login', state: { emailConfirmation: 'USERNAME' } })
    } catch (err) {
      const error = err as AxiosError

      actions.setSubmitting(false)
      actions.setStatus({ msg: `auth.${error?.message}` })
    }
  }
  // Return the login form
  return (
    <MerinioCard
      title="auth.FORGOT_USERNAME_CARD"
      titleLink={
        <NavLink to="/login">
          <i className="fas fa-caret-left mr-2"></i>
          {t('auth.RETURN')}
        </NavLink>
      }
    >
      <Card.Body>
        <Formik validationSchema={ForgotUsernameSchema} initialValues={initialValues} onSubmit={onSubmit}>
          {({ status, isSubmitting, dirty, setStatus }) => (
            <Form dirty={!!dirty && !isSubmitting}>
              <Alert onClose={() => setStatus()} show={!!status?.msg}>
                {status?.msg}
              </Alert>
              <Input type="email" name="email" module="auth" required />
              <Button type="submit" isSubmitting={isSubmitting} text="auth.SUBMIT" />
              <Prompt when={dirty} message="Are you sure you want to leave?" />
            </Form>
          )}
        </Formik>
      </Card.Body>
    </MerinioCard>
  )
}

export default ForgotUsername
